import React from 'react';
import PropTypes from 'prop-types';
import Image from '../image';
import Assembly from '../assemblies/component';
import { RichTextPropTypes } from '../../prop-types';
import { consistentString } from '../../utils/content-formatting';
// Styles
import {
  Wrapper,
  HeaderText,
  FlexContainer,
  ContentSemi,
  TextWrapper,
} from './styles';
import RichText from '../rich-text';
import { CTAAssembly } from '../cta';
import { Container } from '../layout';
import { useLayout } from '../layout/context';

const TwoColumnTextAndImageBlock = ({
  backgroundColor,
  headerText,
  leftColumnText,
  leftColumnCalloutBanners,
  rightColumnText,
  rightColumnImage,
  rightColumnCta,
  rightColumnCalloutBanners,
  removeMarginBottom,
}) => {
  const { insideContainer } = useLayout();

  if (!leftColumnText) {
    return null;
  }

  return (
    <Wrapper
      $backgroundColor={backgroundColor}
      $padding={!insideContainer}
      $removeMarginBottom={removeMarginBottom}
    >
      <Container $padding={!insideContainer || backgroundColor === 'grey'}>
        {headerText ? (
          <HeaderText $backgroundColor={backgroundColor}>
            {headerText}
          </HeaderText>
        ) : null}
        <FlexContainer>
          <ContentSemi>
            <TextWrapper $backgroundColor={backgroundColor}>
              <RichText
                backgroundColor={backgroundColor}
                richText={leftColumnText}
              />
            </TextWrapper>
            {leftColumnCalloutBanners &&
              leftColumnCalloutBanners.map((calloutBanner, i) => (
                <Assembly key={calloutBanner.id + i} assembly={calloutBanner} />
              ))}
          </ContentSemi>
          <ContentSemi>
            {rightColumnText && (
              <TextWrapper $backgroundColor={backgroundColor}>
                <RichText
                  backgroundColor={backgroundColor}
                  richText={rightColumnText}
                />
              </TextWrapper>
            )}
            {rightColumnCta && (
              <CTAAssembly
                contentfulData={{ ...rightColumnCta, marginBottom: true }}
              />
            )}
            {rightColumnImage && (
              <Image image={rightColumnImage} width={1000} />
            )}

            {rightColumnCalloutBanners &&
              rightColumnCalloutBanners.map((calloutBanner, i) => (
                <Assembly key={calloutBanner.id + i} assembly={calloutBanner} />
              ))}
          </ContentSemi>
        </FlexContainer>
      </Container>
    </Wrapper>
  );
};

TwoColumnTextAndImageBlock.propTypes = {
  headerText: PropTypes.string,
  leftColumnText: RichTextPropTypes,
  leftColumnCalloutBanners: PropTypes.array,
  rightColumnText: RichTextPropTypes,
  rightColumnImage: PropTypes.object,
  rightColumnCalloutBanners: PropTypes.array,
  rightColumnCta: PropTypes.object,
  backgroundColor: PropTypes.oneOf(['white', 'black', 'grey']),
  removeMarginBottom: PropTypes.bool,
};

TwoColumnTextAndImageBlock.defaultProps = {
  backgroundColor: 'white',
};

export default TwoColumnTextAndImageBlock;

export const TwoColumnTextAndImageBlockAssembly = ({ contentfulData }) => (
  <TwoColumnTextAndImageBlock
    headerText={contentfulData.headerText}
    leftColumnText={contentfulData.leftColumnText}
    leftColumnCalloutBanners={contentfulData.leftColumnCalloutBanners}
    rightColumnText={contentfulData.rightColumnText}
    rightColumnImage={contentfulData.rightColumnImage}
    rightColumnCalloutBanners={contentfulData.rightColumnCalloutBanners}
    rightColumnCta={contentfulData.rightColumnCta}
    backgroundColor={consistentString(
      contentfulData.backgroundColor || 'white'
    )}
    removeMarginBottom={contentfulData.removeMarginBottom}
  />
);

TwoColumnTextAndImageBlockAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
